import vue from "vue"
import Vuex from "vuex"
import axios from "axios"
import authenticate from "../erp_src/helper/authenticate"
import auth from "./modules/auth"

vue.use(Vuex)

export default new Vuex.Store({
	strict: process.env.NODE_ENV !== "production",
	modules: {
		auth,
	},

	state: {
		departments: [],
		flash: { show: false, text: null, type: null },
		loader: false,
		messageCountError: false,
		messageCountInterval: null,
		messageCount: 0,
		selectedDepartment: { id: "", name: "", features: [] },
		prefectures: [
			"北海道",
			"青森県",
			"岩手県",
			"宮城県",
			"秋田県",
			"山形県",
			"福島県",
			"茨城県",
			"栃木県",
			"群馬県",
			"埼玉県",
			"千葉県",
			"東京都",
			"神奈川県",
			"新潟県",
			"富山県",
			"石川県",
			"福井県",
			"山梨県",
			"長野県",
			"岐阜県",
			"静岡県",
			"愛知県",
			"三重県",
			"滋賀県",
			"京都府",
			"大阪府",
			"兵庫県",
			"奈良県",
			"和歌山県",
			"鳥取県",
			"島根県",
			"岡山県",
			"広島県",
			"山口県",
			"徳島県",
			"香川県",
			"愛媛県",
			"高知県",
			"福岡県",
			"佐賀県",
			"長崎県",
			"熊本県",
			"大分県",
			"宮崎県",
			"鹿児島県",
			"沖縄県",
		],
		sideareaFlag: false,
	},
	getters: {
		flash: (state) => state.flash,
		departments: (state) => state.departments,
		department: (state) => (id) => state.departments.find((d) => id == d.id),
		loader: (state) => state.loader,
		messageCount: (state) => state.messageCount,
		messageCountError: (state) => state.messageCountError,
		selectedDepartment: (state) => state.selectedDepartment,
		selectedDepartmentFeatures: (state) => state.selectedDepartment.features,
		sideareaFlag: (state) => state.sidearea_flag,
	},

	mutations: {
		setFlash(state, { text, type, show = true }) {
			state.flash = { show: show, text: text, type: type }
		},
		setLoader(state, show = true) {
			state.loader = show
		},
		setDepartments(state, departments) {
			state.departments = departments
		},
		createDepartment(state, department) {
			state.departments.push(department)
		},
		setSelectedDepartment(state, department) {
			state.selectedDepartment = department
		},
		setSideareaFlag(state, flag) {
			state.sideareaFlag = flag
		},
		updateDepartment(state, newDepartment) {
			state.departments = state.departments.map((d) => {
				if (d.id == newDepartment.id) {
					return newDepartment
				} else {
					return d
				}
			})
		},
		deleteDepartment(state, id) {
			const department = state.departments.find((d) => id == d.id)
			const i = state.departments.indexOf(department)
			state.departments.splice(i, 1)
		},
		setMessageCount(state, messageCount) {
			state.messageCount = messageCount
		},
		reduceMessageCount(state) {
			state.messageCount -= 1
		},
		setMessageInterval(state, interval) {
			state.messageCountInterval = interval
		},
		clearMessageInterval(state) {
			state.messageCountError = true
			clearInterval(state.messageCountInterval)
			state.messageCountInterval = null
		},
	},
	actions: {
		setFlash({ commit, dispatch }, { text, type }) {
			commit("setFlash", { text, type })
			setTimeout(() => {
				dispatch("hideFlash")
			}, 5000)
		},
		hideFlash({ commit }) {
			commit("setFlash", { text: null, type: null, show: false })
		},
		readMessage({ commit }) {
			commit("reduceMessageCount")
		},
		setMessageInterval({ commit, dispatch }, _) {
			const interval = setInterval(() => {
				dispatch("fetchMessageCount")
			}, 300000)
			commit("setMessageInterval", interval)
		},
		fetchMessageCount({ commit }) {
			const headers = authenticate.setHeader()
			axios
				.get("/erp/v1/message_counts", { headers })
				.then((res) => {
					commit("setMessageCount", res.data.message_count)
				})
				.catch((err) => {
					commit("clearMessageInterval")
				})
		},
	},
})
